import React, { useEffect, useState } from "react";
import { Toaster } from "sonner";
import TopNav from "@/components/dashboard/TopNav";
import { api, endpoints } from "@/lib/api";
import { resolveUserId } from "@/lib/session";
import { DASHBOARD } from "@/constants/testIds";

/**
 * Shared page wrapper: dark theme, TopNav (with founding badge once loaded),
 * toaster, and constrained main container. Used by all secondary routes.
 */
export const PageShell = ({ children, testId }) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        let ignore = false;
        api.get(endpoints.userImpact(resolveUserId()))
            .then((r) => !ignore && setUser(r.data))
            .catch(() => {});
        return () => {
            ignore = true;
        };
    }, []);

    return (
        <div data-testid={testId || DASHBOARD.root} className="min-h-screen bg-[#050505] text-white">
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#0a0a0a",
                        border: "1px solid #27272a",
                        color: "#fff",
                    },
                }}
            />
            <TopNav user={user} />
            <main className="mx-auto max-w-[1440px] px-4 py-8 sm:px-6 sm:py-10 lg:px-10 lg:py-14">
                {children}
            </main>
        </div>
    );
};

export default PageShell;
